import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';

import { ConstantsModule } from '../constants/constants.module';
import { FolderAddComponent } from '../folder-add/folder-add.component';
import { FolderEditMailComponent } from '../folder-edit-mail/folder-edit-mail.component';
import { FolderEditRightsComponent } from '../folder-edit-rights/folder-edit-rights.component';
import { FolderEditComponent } from '../folder-edit/folder-edit.component';
import { FolderReminderComponent } from '../folder-reminder/folder-reminder.component';
import { FolderRestartComponent } from '../folder-restart/folder-restart.component';
import { FolderStartComponent } from '../folder-start/folder-start.component';
import { FolderUpdaterComponent } from '../folder-updater/folder-updater.component';
import { ConnectedPage } from '../root_classes/connected-page';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent extends ConnectedPage implements OnInit {

	public stateChoice: any[] = [];

	private _userId: string = "";

	public userDatas: any = {
		username: "",
		name: "",
		firstname: "",
		role: "",
		company_name: "",
		company_id: ""
	};

	// Folder list hanlder.
	public columnsFolder: any[] = [];
	public datasFolder: any[] = [];
	public firstFolder: number = 0;
	public rowsFolder: number = 10;

  constructor(private activatedRoute: ActivatedRoute, constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal) {
	  super(constantsModule, cookieService, httpClient, router, modalService); 

	  // Creating filter lists.
	  this.stateChoice = [
		  {label: "En attente", value:'D'},
		  {label: "En cours", value:'R'},
		  {label: "Terminé", value: 'E'},
		  {label: "Désactivé", value: 'X'}
	  ];
  }

	ngOnInit(): void {
		// Reading parameters from the route.
		this._userId = this.activatedRoute.snapshot.params.id;

		// Loading users details datas.
		var newDatas = { id: this._userId };
		this.put("/api/user-detail", newDatas,
			(data) => {
				// Storing user datas.
				this.userDatas = {
					username: data.RES.local.username,
					name: data.RES.name,
					firstname: data.RES.firstname,
					role: data.RES.role,
					company_name: data.RES.company != undefined ? data.RES.company.name : "",
					company_id: data.RES.company != undefined ? data.RES.company._id : ""
				};
				this.loadFolderList();
			},
			(err) => {
				this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
			}
		);

		// Building columns for folders.
		this.columnsFolder = [
			{field:"name", header:"Nom", sort:"name"},
			{field:"path", header:"Chemin", sort:"path"},
			{field:"state", header:"Etat", sort:"state"},
			{field:"endDateVal", header:"Date de fin", sort:"endDateVal"}
		];
	}

	private loadFolderList() {
		var newDatas = { id: this._userId, company: null};
		if (this.userDatas.company_id != "") {
			newDatas = { id: this._userId, company: this.userDatas.company_id};
		}

		// Loading users details datas.
		this.put("/api/user-detail-list-folder", newDatas,
			(data) => {
				// Storing list of folders.
				if (data["DATA"] == "OK") {
					this.datasFolder = [...data["RES"]];
				} else {
					this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
				}
			},
			(err) => {
				this.alertLine.alertDangerMessage = "Erreud d'accès à la base de données. Contactez votre administrateur.";
			}
		);
	}

	public filterColumns(event: Event): string {
		return (<HTMLInputElement> event.target).value;
	}

	// =================
	// Gestion des dossiers.
	// =================
	public prevFolder(): void {
		// Set to the previous folder page.
		this.firstFolder = this.firstFolder - this.rowsFolder;
	}

	public resetFolder(): void {
		// Clear the full folder data.
		this.firstFolder = 0;
	}

	public nextFolder(): void {
		// Set to the next folder page.
		this.firstFolder = this.firstFolder + this.rowsFolder;
	}

	public isFirstPageFolder(): boolean {
    	// Test if the displayed folder page is the first one.
		return this.datasFolder ? this.firstFolder === 0 : true;
	}

	public isLastPageFolder(): boolean {
    	// Test if the displayed folder page is the last one.
		return this.datasFolder ? (this.datasFolder.length - this.firstFolder) < this.rowsFolder : true
	}

	public hasFolder(): boolean {
		// Returns if the list of the folder table is empty.
		return this.datasFolder.length !== 0;
	}

	public doAddFolder(): void {
		var newFolderParams = {
			"FROM": "USER-DETAILS",
			"USER": {id: this._userId, username: this.userDatas.username},
		};
		this.runModalDialogWithParameters(FolderAddComponent, newFolderParams,
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur de base de données. Contactez votre administrateur.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Impossible d'ajouter le dossier: Le dossier existe déjà.";
						break;
					case "CANNOT CREATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de création de la base de données. Contactez votre administrateur.";
						break;
					case "INVALID DATE":
						this.alertLine.alertDangerMessage = "Date d'arrêt saisie invalide : veuillez saisir une date d'arrêt postérieur à celle du jour.";
						break;
         			default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside or press space bar the dialog.
				if (reason != 1 && reason != 0) {
					// Inserting new item inside the list.
					var newFolder = {
						"_id": reason["_id"],
						"name": reason["name"],
						"path": reason["path"],
						"endDate": reason["endDate"],
						"endDateVal": reason["endDateVal"],
						"state": "D",
					};

					// Updating for sorting.
					this.datasFolder = [ ...this.datasFolder, newFolder ];

					// Message informatif.
					this.alertLine.alertSuccessMessage = "Dossier ajouté.";
				}
			}
		);
	}

	public doEditFolder(folderName: string, folderId: string, folderEndDate: Date): void {
		this.runModalDialogWithParameters(FolderEditComponent, {name: folderName, id: folderId, endDate: folderEndDate},
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver le dossier à renommer. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Un dossier porte déjà le nom demandé. Opération annulée.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de données. Contactez votre administrateur.";
						break;
					case "INVALID DATE":
						this.alertLine.alertDangerMessage = "Date d'arrêt saisie invalide : veuillez saisir une date d'arrêt postérieur à celle du jour.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside the dialog.
				if (reason != 1 && reason != 0) {
					// Reloading folder list.
					this.loadFolderList();
					
					// Updating the sorting.
					this.filterDataFolder();

					// Message informatif.
					this.alertLine.alertSuccessMessage = "Dossier modifié.";
				}
			}
		);
	}

	public doEditRightsFolder(folderName: string, folderId: string): void {
		var newUserParams = {
			"name": folderName, 
			"id": folderId
		};
		this.runModalDialogWithParameters(FolderEditRightsComponent, newUserParams,
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver le dossier à renommer. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de données. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside the dialog.
				if (reason != 1 && reason != 0) {
					var newDatas = { id: this._userId, company: undefined };
					if (this.userDatas.company_id != "") {
						newDatas = { id: this._userId, company: this.userDatas.company_id };
					}

					// Loading users list.
					this.put("/api/user-detail-list-folder", newDatas,
						(data) => {
							// Storing list of folders.
							if (data.DATA == "OK") {
								this.datasFolder = [...data.RES];
							} else {
								this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
							}
						},
						(err) => {
							this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						}
					);
			
					// Filtering again datas.
					this.filterDataFolder();

					// Message informatif.
					this.alertLine.alertSuccessMessage = "Droits du dossier modifié.";
				}
			}
		);
	}

	public doStartFolder(folderId: string, folderName: string): void {
		this.runModalDialogWithParameters(FolderStartComponent, {id: folderId, name:folderName},
			(result:any) => {
				if (result == "FERMETURE") return;
				this.alertLine.alertDangerMessage = "Impossible de démarrer le dossier.";
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					this.alertLine.alertSuccessMessage = "Dossier démarré.";

					// Replacing the state on the list.
					for(var folderIndex in this.datasFolder) {
						var folder = this.datasFolder[folderIndex];
						if (folder._id == folderId) {
							folder.state = "R";
							break;
						}
					}

					// Fitering again datas.
					this.filterDataFolder();
				}
			}
		);
	}

	public doRestartFolder(folderId: string, folderName: string): void {
		this.runModalDialogWithParameters(FolderRestartComponent, {id: folderId, name:folderName},
			(result:any) => {
				if (result == "FERMETURE") return;
				this.alertLine.alertDangerMessage = "Impossible de redémarrer le dossier.";
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					this.alertLine.alertSuccessMessage = "Dossier redémarré.";

					// Replacing the state on the list.
					for(var folderIndex in this.datasFolder) {
						var folder = this.datasFolder[folderIndex];
						if (folder._id == folderId) {
							folder.state = "R";
							folder.endDate = reason.endDate;
							folder.endDateVal = reason.endDateVal;
							break;
						}
					}

					// Fitering again datas.
					this.filterDataFolder();
				}
			}
		);
	}

	public doEditFolderMail(folderId:string, folderName:string): void {
		this.runModalDialogWithParameters(FolderEditMailComponent, {id: folderId, name:folderName},
			(result:any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver le dosser à mettre à jour. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de donénes. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					this.alertLine.alertSuccessMessage = "Email modifié.";
				}
			}
		);
	}

	public doSendFolderReminder(folderId:string, folderName:string): void {
		this.runModalDialogWithParameters(FolderReminderComponent, {id:folderId, name:folderName},
			(result:any) => {
				// Nothing.
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					if (reason.DATA == "OK") {
						this.alertLine.alertSuccessMessage = "Emails de rappel envoyés (Nombre: " + reason.NB + ").";
					} else {
						this.alertLine.alertDangerMessage = "Impossible d'envoyer les emails de rappel. Contactez votre administrateur.";
					}
				}
			}
		);
	}

	public doSendForUpdateFolder(folderId:string): void {
		this.runModalDialogWithParameters(FolderUpdaterComponent, {id:folderId},
			(result:any) => {
				// Nothing.
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) { 
					if (reason.DATA == "OK") {
						this.alertLine.alertSuccessMessage = "Emails de rappel envoyés (Nombre: " + reason.NB + ").";
					} else {
						this.alertLine.alertDangerMessage = "Impossible d'envoyer les emails de rappel. Contactez votre administrateur.";
					}
				}
			}
		);
	}

	public doDeactivateFolder(folderId: string): void {
		// Sending stoping to the server.
		var newData = {
			"folderid": folderId
		};
		this.put("/api/folder-deactivate", newData,
				(response: any) => {
					this.alertLine.alertSuccessMessage = "Dossier désactivé.";
				},
				(err: any) => {
					this.alertLine.alertDangerMessage = "Impossible de désactiver la dossier.";
				});

		// Replacing the state on the list.
		for(var folderIndex in this.datasFolder) {
			var folder = this.datasFolder[folderIndex];
			if (folder._id == folderId) {
				folder.state = "X";
				break;
			}
		}

		// Filtering again datas.
		this.filterDataFolder();
	}

	public doActivateFolder(folderId: string): void {
		// Sending stoping to the server.
		var newData = {
			"folderid": folderId
		};
		this.put("/api/folder-activate", newData,
			(response: any) => {
				this.alertLine.alertSuccessMessage = "Dossier activé.";
				// Replacing the state on the list.
				for(var folderIndex in this.datasFolder) {
					var folder = this.datasFolder[folderIndex];
					if (folder._id == folderId) {
						folder.state = response.RES;
						break;
					}
				}
		
				// Filtering again datas.
				this.filterDataFolder();
			},
			(err: any) => {
				this.alertLine.alertDangerMessage = "Impossible d'activer la dossier.";
		});
	}

	public filterDataFolder(): void {
		// Force filtering after modifying data.
		this.datasFolder = [ ...this.datasFolder];
	}
}
